import React from 'react';
import { useTranslation } from 'react-i18next';
import { GlobeIcon, BookOpenIcon, CodeIcon, SparklesIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  const {
    t
  } = useTranslation();
  const features = [{
    icon: BookOpenIcon,
    label: t('hero.english'),
    gradientClass: 'bg-gradient-to-br from-teal-400 to-teal-600'
  }, {
    icon: CodeIcon,
    label: t('hero.programming'),
    gradientClass: 'bg-gradient-to-br from-blue-400 to-blue-600'
  }, {
    icon: GlobeIcon,
    label: t('hero.global'),
    gradientClass: 'bg-gradient-to-br from-indigo-400 to-indigo-600'
  }];
  return <section className="relative w-full min-h-screen flex flex-col items-center justify-center px-6 py-20 overflow-hidden" data-id="element-85">
      {/* Animated background */}
      <div className="absolute inset-0 bg-gradient-to-br from-teal-50 via-blue-50 to-indigo-50" data-id="element-86">
        <div className="absolute inset-0 opacity-30" data-id="element-87">
          <div className="absolute top-20 left-20 w-72 h-72 bg-teal-300 rounded-full mix-blend-multiply filter blur-3xl animate-pulse" data-id="element-88" />
          <div className="absolute top-40 right-20 w-72 h-72 bg-blue-300 rounded-full mix-blend-multiply filter blur-3xl animate-pulse animation-delay-2000" data-id="element-89" />
          <div className="absolute bottom-20 left-1/2 w-72 h-72 bg-indigo-300 rounded-full mix-blend-multiply filter blur-3xl animate-pulse animation-delay-4000" data-id="element-90" />
        </div>
      </div>
      <div className="relative max-w-6xl mx-auto text-center z-10" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="mb-12" data-id="element-92">
          <div className="inline-block p-1 bg-gradient-to-r from-teal-500 to-blue-500 rounded-3xl mb-8" data-id="element-93">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vFiyUZ5U9tjaQyeYT1Y755/WhatsApp_Image_2025-10-22_at_20.06.11_%281%29.jpg" alt="Zoe Institute Logo" className="w-56 h-auto rounded-3xl bg-white p-4" data-id="element-94" />
          </div>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-95">
          <h1 className="text-6xl md:text-8xl font-bold mb-6 tracking-tight" data-id="element-96">
            <span className="text-gradient" data-id="element-97">ZOE INSTITUTE</span>
          </h1>
          <div className="flex items-center justify-center gap-2 mb-8" data-id="element-98">
            <SparklesIcon className="w-6 h-6 text-teal-600 animate-pulse" data-id="element-99" />
            <p className="text-2xl md:text-4xl text-slate-700 font-light italic" data-id="element-100">
              {t('hero.motto')}
            </p>
            <SparklesIcon className="w-6 h-6 text-blue-600 animate-pulse" data-id="element-101" />
          </div>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="flex flex-wrap justify-center gap-6 mt-20" data-id="element-102">
          {features.map((feature, index) => {
          const Icon = feature.icon;
          return <motion.div key={index} whileHover={{
            scale: 1.05,
            y: -5
          }} transition={{
            type: 'spring',
            stiffness: 300
          }} className="glass rounded-2xl p-6 shadow-xl hover:shadow-2xl transition-all" data-id="element-103">
                <div className={`w-16 h-16 ${feature.gradientClass} rounded-2xl flex items-center justify-center mb-4 mx-auto shadow-lg`} data-id="element-104">
                  <Icon className="w-8 h-8 text-white" data-id="element-105" />
                </div>
                <p className="text-base font-semibold text-slate-800" data-id="element-106">
                  {feature.label}
                </p>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}